/** A small arc that turns while work is in progress. Holds still when reduced motion is on. */
const Spinner = ({ size = 16, label }) => {
  return (
    <svg className="comp-spinner" width={size} height={size} viewBox="0 0 24 24" fill="none" role={label ? 'img' : undefined} aria-label={label} aria-hidden={label ? undefined : 'true'}>
      <circle className="comp-spinner__track" cx="12" cy="12" r="9" strokeWidth="2" />
      <path className="comp-spinner__arc" d="M12 3a9 9 0 0 1 9 9" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

export default Spinner;
